const state = {
  allServices: [],
  currentService: {},
};

const getters = {
  allServices: () => {
    return state.allServices?.map((category) => ({
      ...category,
      list: category.list.map((service) => ({
        ...service,
        pinned: service.slug === "/dashboard",
      })),
    }));
  },
  currentService: (state) => state.currentService,
};

const mutations = {
  UPDATE_ALL_SERVICE(state, allServices) {
    state.allServices = allServices;
  },
  UPDATE_CURRENT_SERVICE(state, currentService) {
    state.currentService = currentService;
  },
};

const actions = {
  updateCurrentService({ commit }, payload) {
    commit("UPDATE_CURRENT_SERVICE", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
